import SmallBankButton from './small-bank-button';

export default SmallBankButton;
